module.exports = __webpack_public_path__ + "static/media/HawkinsGroup-logo-ref.32aace54.png";